import { render, staticRenderFns } from "./dealerTable.vue?vue&type=template&id=50260458&scoped=true"
import script from "./dealerTable.vue?vue&type=script&lang=js"
export * from "./dealerTable.vue?vue&type=script&lang=js"
import style0 from "./dealerTable.vue?vue&type=style&index=0&id=50260458&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50260458",
  null
  
)

export default component.exports